import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

interface VStackProps {
  $spacing?: number;
}

export const VStack = styled.div.withConfig({ componentId: 'sc-d43yjr-0' })<VStackProps>`
    display: flex;
    flex-direction: column;

    ${({ $spacing }) =>
      $spacing &&
      css`
            gap: ${size($spacing)};
        `}
`;
